import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
/**
 * `Componente` para mostrar ventanas modales tanto de confirmación como de aceptación
 */
@Component({
	selector: 'app-confirm',
	templateUrl: './confirm.component.html',
	styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent {
	@Input() title: string = '';
	@Input() body: string = '';
	@Input() buttonText: string = 'Aceptar';
	@Input() modalConfirm: boolean = false;
	@Input() buttonLeft: string = this.translate.instant('common.no');
	@Input() buttonRight: string = this.translate.instant('common.yes');

	constructor(public activeModal: NgbActiveModal, private translate: TranslateService) {}
}
